import React, { useRef, useState, useCallback, useEffect } from 'react';
import cn from 'classnames';
import mergeRefs from 'react-merge-refs';
import { createTextMaskInputElement } from 'text-mask-core';
import { Input } from '@alfalab/core-components-input/esm';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var styles = {"textHidden":"masked-input__textHidden_1uh7i"};
require('./index.css')

// Символ плейсхолдера не может входить в маску, поэтому вместо пробела используется \u2000
var PLACEHOLDER_CHAR = '\u2000';
var MaskedInput = React.forwardRef(function (_a, ref) {
    var _b;
    var mask = _a.mask, _c = _a.keepCharPositions, keepCharPositions = _c === void 0 ? false : _c, value = _a.value, defaultValue = _a.defaultValue, className = _a.className, onBeforeDisplay = _a.onBeforeDisplay, onChange = _a.onChange, onClear = _a.onClear, restProps = __rest(_a, ["mask", "keepCharPositions", "value", "defaultValue", "className", "onBeforeDisplay", "onChange", "onClear"]);
    var inputRef = useRef(null);
    var textMask = useRef(null);
    var _d = useState(value || defaultValue || ''), inputValue = _d[0], setInputValue = _d[1];
    // Не показываем сырое значение до применения маски
    var _e = useState(true), textHidden = _e[0], setTextHidden = _e[1];
    var update = useCallback(function (newValue) {
        if (newValue === void 0) { newValue = ''; }
        if (textMask.current && inputRef.current) {
            try {
                textMask.current.update(newValue);
            }
            catch (e) {
                // ignore masking errors
            }
            setInputValue(inputRef.current.value);
        }
    }, []);
    var handleInputChange = useCallback(function (event) {
        update(event.target.value);
        if (onChange) {
            onChange(event, {
                value: event.target.value,
            });
        }
    }, [onChange, update]);
    var handleClear = useCallback(function (event) {
        update('');
        if (onClear)
            onClear(event);
    }, [onClear, update]);
    useEffect(function () {
        if (inputRef.current) {
            textMask.current = createTextMaskInputElement({
                mask: mask,
                inputElement: inputRef.current,
                pipe: onBeforeDisplay,
                guide: false,
                keepCharPositions: keepCharPositions,
                showMask: false,
                placeholderChar: PLACEHOLDER_CHAR,
                rawValue: '',
                currentCaretPosition: 0,
                previousConformedValue: '',
            });
        }
    }, [onBeforeDisplay, mask, keepCharPositions]);
    useEffect(function () {
        update(value || defaultValue);
    }, [value, update, defaultValue]);
    useEffect(function () {
        setTextHidden(false);
    }, []);
    return (React.createElement(Input, __assign({}, restProps, { className: cn(className, (_b = {}, _b[styles.textHidden] = textHidden, _b)), value: inputValue, onChange: handleInputChange, onClear: handleClear, ref: mergeRefs([ref, inputRef]) })));
});

export { MaskedInput, PLACEHOLDER_CHAR };
